<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>高温下的坚守 防控中的担当：东进公司全力应对基孔肯亚热彰显国企本色</h2>
        <div id="meta_content">
          <span class="rich_b"> 东进防控 </span>
          <span id="rich_c">
            <span>2025-08-28 16:19</span>
            广东
          </span>
        </div>
        <p>
          疫情就是命令，防控就是责任。东进公司第一时间将基孔肯亚热防控工作纳入重要议事日程，迅速成立专项工作领导小组，主动对接疾控部门、卫健局及地方政府形成联动机制，共同研判疫情态势，制定科学精准的防控实施方案，同时积极支援佛山疫情防控。依托国有企业强大的资源整合能力，公司高效调配人力、物力、财力等关键要素，创新引入无人机作业设备纳入防控物资体系，为防控工作的有序开展提供了坚实保障。
        </p>
        <img width="100%" :src="img[0]" alt="" />
        <p>
          东进公司于7月28日组建“疫情防控支援突击队”，驰援佛山市，开展专业消杀工作。同时，承担了我市黄江、大岭山等9个镇街，以及东莞理工学院、虎门港、巴士公司、电信大院等多家单位的专业消杀工作。截至8月27日，东进公司累计投入防控人员1950人次，完成蚊虫消杀面积4875万平方米(相当于6800个标准足球场)，覆盖东莞、佛山两市10个镇街。
        </p>
        <img width="100%" :src="img[1]" alt="" />
        <p>
          作为肩负重任的国有企业，东进公司始终牢记“国之大者”，构建起多层次、全方位的防控体系；在物资保障方面，向基层单位定向捐赠防护用品等急需物资，切实缓解基层防控物资短缺压力；在专业支援方面，组建由国家二级有害生物防制技师领衔的专业队伍深入基层，利用无人机搭载超低容量喷雾器，对社区楼顶、荒地、树林等人工难以抵达的区域开展全覆盖药物喷洒。通过无人机搭载高清摄像头，对蚊虫孳生地进行空中巡查，精准定位积水点、垃圾堆积处等隐患区域，形成“空中巡查+地面处置”的闭环管理。在机制建设方面，与各服务单位联合建立长效联防联控机制，通过数据共享、联合巡检等措施，筑牢疫情反弹防线，确保疫情不反弹、不扩散。
        </p>
        <p>
          在培训方面，公司积极与交控集团、东实集团、港务集团等多家大型国企单位组织开展系统化、多维度的专项培训活动，着力打造一支理论扎实、技术过硬、响应迅速的基层防控队伍。
        </p>
        <img width="100%" :src="img[2]" alt="" />
        <img width="100%" :src="img[3]" alt="" />
        <p>
          在这场没有硝烟的战役中，全体党员在东鸿党支部的带领下主动请缨、冲锋在前，组建“党员先锋队”深入社区楼栋开展环境消杀、防疫宣传等志愿服务，让鲜红的党旗在抗疫一线高高飘扬，成为群众心中最可靠的“主心骨”。
        </p>
        <img width="100%" :src="img[4]" alt="" />
        <p>
          基孔肯亚热防控工作考验着企业的责任担当，东进公司以坚定的政治自觉、务实的工作举措，以实际行动书写着彰显国企担当与作为的精彩答卷。展望未来，公司将持续秉持“人民至上、生命至上”的理念，在服务国家公共卫生战略、保障人民生命健康安全中展现更大作为，为构建人类卫生健康共同体贡献坚实的国企力量。
        </p>
        <img width="100%" :src="img[5]" alt="" />

        <h3>我们还提供多元化服务</h3>
        <img width="100%" :src="img[6]" alt="" />
        <h3>扫码关注我们了解更多</h3>
        <div>
          <img :src="img[7]" alt="" />
        </div>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span>&nbsp;</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'News14' })">世界害虫日｜守护健康，从“虫...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: [
        require("@/assets/news15_1.png"),
        require("@/assets/news15_2.jpg"),
        require("@/assets/news15_3.jpg"),
        require("@/assets/news15_4.jpg"),
        require("@/assets/news15_5.jpg"),
        require("@/assets/news15_6.jpg"),
        require("@/assets/news8-4.png"),
        require("@/assets/news8-7.png"),
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.black {
  font-weight: 700;
}

.kongxi {
  height: 10px;
}

.big-div {
  display: flex;
  justify-content: space-evenly;
}

.small-div {
  text-align: center;
}

.small-div1 img {
  width: 258px;
  height: 258px;
}

.small-div2 img {
  width: auto;
  height: auto;
}

.caption {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.content {
  width: 90%;
  margin: 0 auto;

  h2 {
    font-family: 黑体, SimHei;
    font-size: 24px;
    margin: 20px 0;
    text-align: center;
  }

  h3 {
    font-weight: normal;
    font-family: 黑体, SimHei;
    font-size: 18px;
    margin: 20px 0;
    text-align: left;
  }

  p {
    font-size: 16px;
    margin: 20px 0;
    text-align: justify;
    text-indent: 2em;
    color: #515050;
    font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
  }
}

.wenzi {
  margin: 0 !important;
  color: rgb(255, 255, 255) !important;
}

@media screen and (max-width: 768px) {
  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      margin: 20px 0;
      text-align: center;
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 20px 0;
      text-align: left;
    }

    p {
      margin: 10px 0;
      text-align: justify;
      text-indent: 2em;
      font-size: 16px;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }
}

#meta_content {
  font-size: 15px;
  padding-left: 2.6em;

  span {
    color: rgba(0, 0, 0, 0.3);
  }

  .rich_b {
    color: #576b95 !important;
  }
}
</style>
